/* global infoPageVars, am4core, infoPageAmCharts, infoPageHelper, numeral */
jQuery(document).ready(function () {
    // check if am4core is defined and if on the info page
    // Note: We used to also check "jQuery('#bocss-info__viewsBox').length == 1", but that was removed
    // because we need the following JS to run even without the #bocss-info__viewsBox rendered in order
    // to get the Average Scroll Depth value.
    if (jQuery('.bocss-info__main').length && typeof am4core !== 'undefined') {
        var info = {

            /**
             * The chart data retrieved from the urls
             */
            chartData: '',

            /**
             * The device data retrieved from the urls
             */
            deviceData: '',

            /**
             * Metric for the views chart (day|week|month|year)
             */
            dateMetricViews: '',

            /**
             * Metric for the device chart (day|week|month|year)
             */
            dateMetricDevices: '',

            /**
             * Updates the all-time views chart data with analytics from the current and old urls
             * @returns {void}
             */
            updateChartData: function () {
                var url = "";
                if (window.hasOwnProperty("bocVars")) {
                    url = bocVars.homeUrl;
                } else {
                    url = window.CFCT.url;
                }
                var ajaxUrl = url + "info" + infoPageVars.url;
                var ajaxData = {
                    'json': 'analytics'
                };

                jQuery.when.apply(jQuery, [this.getData(ajaxUrl, ajaxData)]).done(this.urlsAjaxDone);
            },

            /**
             * Get the data associated with each Url
             * @param {string} ajaxUrl The url to request the analytical data
             * @param {array} ajaxData Variables to be sent in the ajax request
             * @returns {*|jQuery} Returns a deferred promise on success
             */
            getData: function (ajaxUrl, ajaxData) {
                var $deferredObject = jQuery.Deferred();

                jQuery.ajax({
                    url: ajaxUrl,
                    data: ajaxData,
                    type: "GET",
                    success: function (response) {
                        // Create the chart if it's the first dataset
                        var newData = response.chartData;
                        var date;
                        // Update chartData
                        if (newData !== '') {
                            // if chartData is empty initialize the objects with current newData
                            if (!info.chartData) {
                                info.chartData = {};
                                info.deviceData = {};
                            }

                            jQuery("#scrollBox .bocss-info__number").text(response.scrollDepthAvg);

                            info.dateMetricViews = response.dateMetricViews;
                            info.dateMetricDevices = response.dateMetricDevices;

                            // Loop through all data points and add the views to the respective date in the chart data
                            for (date in newData[0]) {
                                if (newData[0].hasOwnProperty(date)) {
                                    if (!info.chartData[date]) {
                                        info.chartData[date] = 0;
                                    }
                                    info.chartData[date] += newData[0][date]["views"];
                                }
                            }

                            for (var entry in newData[1]) {
                                if (newData[1].hasOwnProperty(entry)) {
                                    date = newData[1][entry]["date"];
                                    if (!info.deviceData[date]) {
                                        info.deviceData[date] = {
                                            'desktop': 0,
                                            'mobile': 0,
                                            'tablet': 0
                                        };
                                    }
                                    var device = newData[1][entry]["device"];
                                    info.deviceData[date][device] += newData[1][entry]["views"];
                                }
                            }

                            info.deviceData = Object.keys(info.deviceData).sort().reduce(
                                function(obj, key) {
                                    obj[key] = info.deviceData[key];
                                    return obj;
                                },
                                {}
                            );
                        }
                        $deferredObject.resolve();
                    },
                    error: function () {
                        $deferredObject.resolve();
                    }
                });
                return $deferredObject.promise();
            },

            /**
             * When the urls Ajax has completed, update the chart and all-time data
             * @returns {void}
             */
            urlsAjaxDone: function () {
                // Convert javascript object back to array for amcharts
                info.reformatData();

                infoPageAmCharts.createCharts();
                infoPageAmCharts.setupLanguages();
                infoPageAmCharts.setupTheme();

                // Check that the main chart data loaded correctly
                if (info.chartData.length > 1) {
                    jQuery('#bocss-info__viewsBox').show();
                    jQuery('#bocss-info__viewsTitle').show();
                    var totalViews = infoPageHelper.getTotalViews(info.chartData);
                    // this is average per period (can be day or week)
                    var averageViews = totalViews / info.chartData.length;
                    if (info.dateMetricViews === 'week') {
                        averageViews = averageViews / 7;
                    }
                    if (info.dateMetricViews === 'month') {
                        averageViews = averageViews / 30;
                    }
                    jQuery("#bocss-info__avgViews .bocss-info__number").text(numeral(averageViews).format('<1'));
                    jQuery("#bocss-info__totalViews .bocss-info__number").text(numeral(totalViews).format());

                    //update data for charts
                    infoPageAmCharts.viewsLineChart.data = info.chartData;
                    infoPageAmCharts.viewsLineChart.allTimeViews = totalViews;

                    //Load charts
                    if (jQuery("#" + infoPageAmCharts.viewsLineChartId).length) {
                        infoPageAmCharts.loadLineChart(info.dateMetricViews);
                    }
                    if (jQuery("#" + infoPageAmCharts.viewsPieChartId).length) {
                        infoPageAmCharts.loadPieChart();
                    }
                } else if (info.chartData.length === 1) {
                    jQuery('#bocss-info__viewsChartContainer').hide();
                    jQuery(".bocss-info__spinner").hide();
                } else {
                    jQuery('#bocss-info__viewsBox').show();
                    jQuery('#bocss-info__viewsTitle').show();
                    jQuery('#bocss-info__viewsChartContainer').hide();
                    jQuery(".bocss-info__spinner").hide();
                    jQuery("#chartMessage").show();
                }
                if (info.deviceData.length > 0) {
                    infoPageAmCharts.deviceChart.data = info.deviceData;
                    if (jQuery("#" + infoPageAmCharts.deviceChartId).length) {
                        infoPageAmCharts.loadDeviceChart(info.dateMetricDevices);
                    }
                } else {
                    jQuery('#bocss-info__deviceChartContainer').hide();
                }

                info.dataLoaded();
                jQuery('#bocss-info__allTimePageViews').css('opacity', 1);
            },

            /**
             * Converts chart data to a format amcharts understands
             * @returns {void}
             */
            reformatData: function () {
                var chartDataFormatted = [];
                var deviceDataFormatted = [];
                var date;
                if (Object.keys(this.chartData).length > 0) {
                    for (date in this.chartData) {
                        if (this.chartData.hasOwnProperty(date)) {
                            chartDataFormatted.push(
                                {
                                    'date': date,
                                    'views': this.chartData[date]
                                });
                        }
                    }
                    this.chartData = chartDataFormatted;
                }

                if (Object.keys(this.deviceData).length > 0) {
                    for (date in this.deviceData) {
                        if (this.deviceData.hasOwnProperty(date)) {
                            // Set device data, if no views exist set the data to 0
                            deviceDataFormatted.push(
                                {
                                    'date': date,
                                    'desktop': this.deviceData[date]['desktop'],
                                    'mobile': this.deviceData[date]['mobile'],
                                    'tablet': this.deviceData[date]['tablet']
                                });
                        }
                    }
                    this.deviceData = deviceDataFormatted;
                }
            },

            /**
             * Removes loading animation once all analytics data has loaded
             * @returns {void}
             */
            dataLoaded: function () {
                jQuery(".bocss-info__loading").hide();
                jQuery("#bocss-info__viewsContent").css("opacity", "1");
                jQuery("#scrollBox .bocss-info__number").css("opacity", "1");
                jQuery("#bocss-info__viewsBox").removeClass("bocss-info__box");
            }
        };
        info.updateChartData();
    }
});
